export default "__VITE_ASSET__DgGUfn2Y__"